import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as API_NAMES from 'self-service-api/constants/ApiNames';
import { getIsAdmin } from 'ui-addon-upgrades/_core/common/eligibility/getIsAdmin';
import { ASSIGN_SEAT, BUY_ADDITIONAL_SEATS, PRICING_PAGE_REDIRECT, REQUEST_SEAT, VIEW_ACCOUNT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { allPurchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
const HUB_PRODUCTS = [API_NAMES.MARKETING_HUB_STARTER, API_NAMES.MARKETING_HUB_PROFESSIONAL, API_NAMES.MARKETING_HUB_ENTERPRISE, API_NAMES.SALES_HUB_STARTER, API_NAMES.SALES_HUB_PROFESSIONAL, API_NAMES.SALES_HUB_ENTERPRISE, API_NAMES.SERVICE_HUB_STARTER, API_NAMES.SERVICE_HUB_PROFESSIONAL, API_NAMES.SERVICE_HUB_ENTERPRISE, API_NAMES.CMS_HUB_STARTER, API_NAMES.CMS_HUB_PROFESSIONAL, API_NAMES.CMS_HUB_ENTERPRISE, API_NAMES.OPERATIONS_HUB_STARTER, API_NAMES.OPERATIONS_HUB_PROFESSIONAL, API_NAMES.OPERATIONS_HUB_ENTERPRISE];
export const shouldOverrideToPPRedirectPM = apiName => {
  return !HUB_PRODUCTS.includes(apiName);
};

const overrideSeatPurchaseMotions = (upgradePointApiName, purchaseMotions, isAdmin) => {
  if (shouldOverrideToPPRedirectPM(upgradePointApiName)) {
    return [PRICING_PAGE_REDIRECT];
  } // Not seats scenario, so use MERCH_CARD purchase motions


  if (!purchaseMotions.includes(VIEW_ACCOUNT) && !purchaseMotions.includes(BUY_ADDITIONAL_SEATS)) {
    return purchaseMotions;
  } // Seats scenario, so override purchase motions


  if (isAdmin) {
    return [ASSIGN_SEAT];
  } else {
    return [REQUEST_SEAT];
  }
};
/*
Temporary solution:
MERCH_CARD location returns viewAccount and buyAdditionalSeats in seats scenarios.
We need to switch these to requestSeat or assignSeat.
*/


const GetPersonalizedPPPurchaseMotions = upgradePointApiName => {
  const [isAdmin, setIsAdmin] = useState();
  useEffect(() => {
    getIsAdmin().then(setIsAdmin).catch(() => setIsAdmin(false));
  }, []);
  const purchaseMotions = useSelector(state => {
    const allPurchaseMotions = allPurchaseMotionsSelector(state);
    const merchCardPurchaseMotions = allPurchaseMotions[MERCH_CARD];
    const upgradePointPurchaseMotions = merchCardPurchaseMotions.purchaseMotions[upgradePointApiName];
    return upgradePointPurchaseMotions ? upgradePointPurchaseMotions.map(({
      key
    }) => key) : [];
  });

  if (!purchaseMotions || !purchaseMotions.length || isAdmin === undefined) {
    return [];
  } else {
    return overrideSeatPurchaseMotions(upgradePointApiName, purchaseMotions, isAdmin);
  }
};

export default GetPersonalizedPPPurchaseMotions;